<template lang="html">
  <v-app v-if="isLapTopCheck">
    <v-content>
      <section>
        <v-img
          :src="require('@/assets/about_us2.png')"
          height="450">
          <v-container grid-list-xl>
            <v-layout align-center>
              <v-flex>
                <h2 class="font-weight-black white--text" style="font-size:55px">เกี่ยวกับเรา</h2>
                <h4 class="font-weight-black white--text" style="font-size:30px">บริษัท แน็กส์ เฟอร์นิชิ่ง จำกัด (Naics Furnishing Co., Ltd.)</h4>
                <span class="subheading white--text">บริษัท แน็กส์ เฟอร์นิชิ่ง จำกัด (Naics Furnishing Co., Ltd.) เป็นบริษัทที่ถูกก่อตั้งขึ้นในปี 2539 โดยครอบครัว พัฒนะพีระพงศ์ เพื่อประกอบธุรกิจผลิตเฟอร์นิเจอร์จากเหล็ก เพื่อจำหน่ายทั้งในต่างประเทศ และ เริ่มมีการผลิตครั้งแรกที่ตำบลดอนลาน อำเภอผักไห่ จังหวัด พระนครศรีอยุธยา ทางโรงงานของเราเป็นผู้เชี่ยวชาญด้านงานตัด ดัด เชื่อม เจาะ และพ่นสีเหล็ก เพื่อแปรรูปให้เป็นสินค้าเฟอร์นิเจอร์ต่างๆ</span>
                <v-divider class="my-3"></v-divider>

                <div class="mb-3 white--text" style="font-size:16px">ดูสินค้าเฟอร์นิเจอร์ต่างๆ เช่น เปลเด็ก ชั้นวางของ โต๊ะ วางของ เก้าอี้ ชั้นวางทีวี เตียงนอน</div>
                <v-btn
                  class="mx-0"
                  color="primary"
                  large
                  :to="{ name: 'product'}"
                >
                  ดูสินค้า
                  <v-icon>shopping_cart</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
      </section>

      <section>
        <v-container grid-list-xl>
          <v-layout row justify-center align-center fill-height>
            <v-flex xs12 md 10>
              <h4 class="font-weight-medium" style="font-size:40px">History | ประวัติบริษัท Game GROUP CO.,LTD.</h4>
            </v-flex>
            <v-flex xs12 md2>
              <v-layout row>
                <v-btn flat color="primary" icon @click="checkLanguage('thai')">
                  <v-img
                    :src="require('@/assets/thailand.png')"
                    :lazy-src="require('@/assets/thailand.png')"
                    contain
                    aspect-ratio="1.7"
                    height="35"
                    @click="checkLanguage('thai')">
                  </v-img>
                </v-btn>
                <v-btn color="primary" flat icon @click="checkLanguage('eng')">
                  <v-img
                    :src="require('@/assets/united-kingdom.png')"
                    :lazy-src="require('@/assets/united-kingdom.png')"
                    contain
                    aspect-ratio="1.7"
                    height="35">
                  </v-img>
                </v-btn>
                <!-- <v-flex xs6>
                  <v-btn flat color="primary" icon @click="checkLanguage('thai')">
                    <v-img
                      :src="require('@/assets/thailand.png')"
                      :lazy-src="require('@/assets/thailand.png')"
                      contain
                      aspect-ratio="1.7"
                      height="35"
                      @click="checkLanguage('thai')">
                    </v-img>
                  </v-btn>
                </v-flex>
                <v-flex xs6>
                  <v-btn color="primary" flat icon @click="checkLanguage('eng')">
                    <v-img
                      :src="require('@/assets/united-kingdom.png')"
                      :lazy-src="require('@/assets/united-kingdom.png')"
                      contain
                      aspect-ratio="1.7"
                      height="35">
                    </v-img>
                  </v-btn>
                </v-flex> -->
              </v-layout>
            </v-flex>

          </v-layout>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-container>
      </section>

    <!--   <section>
      <v-layout align-center justify-center row fill-height>
        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </v-layout>
    </section> -->

      <section v-if="thai">
        <section>
          <v-container grid-list-xl>
            <v-layout row wrap>
              <v-flex xs6>
                <v-flex xs12>
                  <h4 class="font-weight-medium" style="font-size:30px">{{ dataThai.history }}</h4>
                </v-flex>
                <v-flex xs12>
                  <p>{{ dataThai.historyDetail }}</p>
                </v-flex>
              </v-flex>
              <v-flex xs6>
                <v-img
                src="https://picsum.photos/510/300?random"
                lazy-src="https://picsum.photos/510/300?random"
                aspect-ratio="2"
                contain>
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                  </v-layout>
                </v-img>
              </v-flex>
            </v-layout>
          </v-container>
        </section>

        <section>
          <v-container grid-list-xl>
            <v-card color="blue darken-2" dark>
              <v-container grid-list-xl>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-img
                    src="https://picsum.photos/510/300?random"
                    lazy-src="https://picsum.photos/510/300?random"
                    aspect-ratio="2"
                    contain>
                      <v-layout
                        slot="placeholder"
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                      </v-layout>
                    </v-img>
                  </v-flex>
                  <v-flex xs6>
                    <v-flex xs12>
                      <h4 class="font-weight-medium" style="font-size:30px">{{ dataThai.missionVision }}</h4>
                    </v-flex>
                    <v-flex xs12>
                      <p>{{ dataThai.missionVisionDetail }}</p>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-container>
        </section>

        <section>
          <v-container grid-list-xl>
            <v-layout row wrap>
              <v-flex xs6>
                <v-flex xs12>
                  <h4 class="font-weight-medium" style="font-size:30px">{{ dataThai.working }}</h4>
                </v-flex>
                <v-flex xs12>
                  <p>{{ dataThai.workingDetail }}</p>
                </v-flex>
              </v-flex>
              <v-flex xs6>
                <v-img
                src="https://picsum.photos/510/300?random"
                lazy-src="https://picsum.photos/510/300?random"
                aspect-ratio="2"
                contain>
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                  </v-layout>
                </v-img>
              </v-flex>
            </v-layout>
          </v-container>
        </section>
      </section>

      <section v-else>
        <section>
          <v-container grid-list-xl>
            <v-layout row wrap>
              <v-flex xs6>
                <v-flex xs12>
                  <h4 class="font-weight-medium" style="font-size:30px">{{ dataEng.history }}</h4>
                </v-flex>
                <v-flex xs12>
                  <p>{{ dataEng.historyDetail }}</p>
                </v-flex>
              </v-flex>
              <v-flex xs6>
                <v-img
                src="https://picsum.photos/510/300?random"
                lazy-src="https://picsum.photos/510/300?random"
                aspect-ratio="2"
                contain>
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                  </v-layout>
                </v-img>
              </v-flex>
            </v-layout>
          </v-container>
        </section>
        <section>
          <v-container grid-list-xl>
            <v-card color="blue darken-2" dark>
              <v-container grid-list-xl>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-img
                    src="https://picsum.photos/510/300?random"
                    lazy-src="https://picsum.photos/510/300?random"
                    aspect-ratio="2"
                    contain>
                      <v-layout
                        slot="placeholder"
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                      </v-layout>
                    </v-img>
                  </v-flex>
                  <v-flex xs6>
                    <v-flex xs12>
                      <h4 class="font-weight-medium" style="font-size:30px">{{ dataEng.missionVision }}</h4>
                    </v-flex>
                    <v-flex xs12>
                      <p>{{ dataEng.missionVisionDetail }}</p>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-container>
        </section>

        <section>
          <v-container grid-list-xl>
            <v-layout row wrap>
              <v-flex xs6>
                <v-flex xs12>
                  <h4 class="font-weight-medium" style="font-size:30px">{{ dataEng.working }}</h4>
                </v-flex>
                <v-flex xs12>
                  <p>{{ dataEng.workingDetail }}</p>
                </v-flex>
              </v-flex>
              <v-flex xs6>
                <v-img
                src="https://picsum.photos/510/300?random"
                lazy-src="https://picsum.photos/510/300?random"
                aspect-ratio="2"
                contain>
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                  </v-layout>
                </v-img>
              </v-flex>
            </v-layout>
          </v-container>
        </section>
      </section>
    </v-content>
  </v-app>
  <!-- mobile version -->
  <v-app v-else>
    <about-us-mobile></about-us-mobile>
  </v-app>
</template>

<script>
import AboutUsMobile from './mobile/aboutUsMobile.vue'
export default {
  components: {
    AboutUsMobile
  },
  props: [
    'isLapTopCheck'
  ],
  data: () => ({
    thai: true,
    eng: false,
    gradient: 'to top right, rgba(20,81,181,.8),rgba(15,32,72,.7)',
    years: [
      {
        color: 'cyan',
        year: '1960'
      },
      {
        color: 'green',
        year: '1970'
      },
      {
        color: 'pink',
        year: '1980'
      },
      {
        color: 'amber',
        year: '1990'
      },
      {
        color: 'orange',
        year: '2000'
      }
    ],
    dataThai: {
      history: 'ประวัติความเป็นมา:',
      historyDetail: 'บริษัท แน็กส์ เฟอร์นิชิ่ง จำกัด (Naics Furnishing Co., Ltd.) เป็นบริษัทที่ถูกก่อตั้งขึ้นในปี 2539 โดยครอบครัว พัฒนะพีระพงศ์ เพื่อประกอบธุรกิจผลิตเฟอร์นิเจอร์จากเหล็ก เพื่อจำหน่ายทั้งในต่างประเทศ และ เริ่มมีการผลิตครั้งแรกที่ตำบลดอนลาน อำเภอผักไห่ จังหวัด พระนครศรีอยุธยา ทางโรงงานของเราเป็นผู้เชี่ยวชาญด้านงานตัด ดัด เชื่อม เจาะ และพ่นสีเหล็ก เพื่อแปรรูปให้เป็นสินค้าเฟอร์นิเจอร์ต่างๆ เช่น เปลเด็ก ชั้นวางของ โต๊ะ วางของ เก้าอี้ ชั้นวางทีวี เตียงนอน เป็นต้นโดยมีทั้งสินค้าที่ออกแบบเองเพื่อนำเสนอให้ลูกค้าพิจารณา และ สินค้าที่ทางลูกค้าสั่งผลิตเอง เรามีความภาคภูมิใจอย่างมากที่สินค้าภายใต้เครื่องหมายการค้า “NF” เป็นที่รู้จักและเชื่อถือได้ของลูกค้าคนไทยมามากกว่า 20 ปี',
      missionVision: 'ภารกิจ และ วิศัยทัศน์:',
      missionVisionDetail: 'ทางโรงงานเรามีความตั้งใจที่จะนำ สินค้าที่มีคุณภาพชั้นนำ และมีมาตรฐาน เข้ามาสู่ในตลาดเฟอร์นิเจอร์ของประเทศไทยในราคาที่สมเหตุสมผล เพื่อให้เป็นที่พึงพอใจของทุกฝ่าย นอกจากนั้นเรายังมุ่งมั่นที่จะพัฒนาตนเองตลอดเวลาเพราะเราพึงคำนึงถึงความต้องการของลูกค้าและการใช้งานสินค้าเป็นหลักเสมอ เพื่อที่จะสามารถ ผลิต และส่งสินค้า ตามความต้องการของลูกค้าได้ตรงเวลาและมีความเสียหายน้อยที่สุด',
      working: 'การทำงาน:',
      workingDetail: 'ทางโรงงานเรามีความถนัดในการผลิตสินค้าโดยกระบวนการ ตัด ดัด เชื่อม พ่นสี เหล็กท่อกลมและเหล็กเหลี่ยมเพื่อนำมาแปรรูปเป็นเฟอร์นิเจอร์ประเภทต่างๆส่งลูกค้า โดยบางครั้งเราได้นำวัตถุดิบอื่นๆ เช่นไม้ปาร์ติเกิ้ล เข้ามาร่วม เพื่อสร้างสินค้าตามที่ลูกค้าต้องการอีกด้วย'
    },
    dataEng: {
      history: 'Our Story: ',
      historyDetail: 'Naics Furnishing Co, Ltd. was found in 1996 by the Pattanapeerapong family in order to manufacture steel pipe furnitures which were dramatically increasing in demand and desired by both domestic and international customers at the time. The factory is located in Pakhai District, Phra Nakhon Sri Ayutthaya province, Thailand. We specialize in cutting, welding, puncturing, and spray painting of steel. Our product list includes baby cribs, market shelves, tables, TV stations, bed frames, and more.  We can also build our products according to our client’s design and specifications, provided that they fall within our specialization. It is our pride that NF products has received continuous supports from our clients, both Thai and others, for the past 20 years.',
      missionVision: 'Mission & Vision:',
      missionVisionDetail: 'We aim to introduce higher-quality products to the current steel pipe furniture market, while maintaining our price range in order to increase quality of life of our users and keeping our business partners satisfied. We always think first about the needs of our clients, and design our furnitures and services around those needs.',
      working: 'Our Work:',
      workingDetail: 'We aim to introduce higher-quality products to the current steel pipe furniture market, while maintaining our price range in order to increase quality of life of our users and keeping our business partners satisfied. We always think first about the needs of our clients, and design our furnitures and services around those needs.'
    }
  }),
  methods: {
    checkLanguage (data) {
      if (data === 'thai') {
        this.thai = true
        this.eng = false
      } else {
        this.thai = false
        this.eng = true
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue